import { render, staticRenderFns } from "./MedicalContentInputForm.vue?vue&type=template&id=43d7d89a&scoped=true&"
import script from "./MedicalContentInputForm.vue?vue&type=script&lang=js&"
export * from "./MedicalContentInputForm.vue?vue&type=script&lang=js&"
import style0 from "./MedicalContentInputForm.vue?vue&type=style&index=0&id=43d7d89a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d7d89a",
  null
  
)

export default component.exports